import {
  combineLatest,
  distinctUntilChanged,
  map,
  type Observable,
  shareReplay,
  startWith,
} from 'rxjs';
import { location$ } from 'router/declarative/location$';
import { unmatchedLocation } from 'router/declarative/location';
import { selectedModule$ } from '../selectedModule$';
import { isPresentationSupportedOnPage } from './isPresentationSupportedOnPage';

export const isPresentationSupportedOnPage$: Observable<boolean> =
  combineLatest([
    selectedModule$,
    location$.pipe(startWith(unmatchedLocation)),
  ]).pipe(
    map(([{ selectedModule }, location]) =>
      isPresentationSupportedOnPage({ selectedModule, location })
    ),
    distinctUntilChanged(),
    shareReplay({ bufferSize: 1, refCount: true })
  );
